import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import EnFilterButtonBase from 'Components/datagrid/filterButtons/EnFilterButtonBase.vue';
import EnFilterTypeSelectButton from 'Components/datagrid/filterButtons/EnFilterTypeSelectButton.vue';
import EnTextField from 'Components/inputs/EnTextField';
import { FilterType } from 'Js/enums/filterType.js';
import { FilterEvent } from '../types/filterEvent';
import { useFilter } from '../composables/filterButtonComposable';
import EnFilterButtonTypePrefix from 'Components/datagrid/filterButtons/EnFilterButtonTypePrefix.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnNumberFilterButton',
    props: /*@__PURE__*/ _mergeModels({
        id: String,
        applyButtonText: String,
        resetButtonText: String,
        noFilterText: String,
        label: String,
        hint: String,
        isMoney: {
            type: Boolean,
            default: false
        },
        initialType: {
            type: String,
            default: FilterType.Equal
        },
        filterTypeSelectionVisible: Boolean,
    }, {
        "modelValue": {},
        "modelModifiers": {},
        "type": { type: String },
        "typeModifiers": {},
        "openOnRender": {},
        "openOnRenderModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(['update:modelValue', 'update:type', 'update:openOnRender', FilterEvent.Input, FilterEvent.FilterUpdated, FilterEvent.FilterReset], ["update:modelValue", "update:type", "update:openOnRender"]),
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const model = _useModel(__props, 'modelValue');
        const type = _useModel(__props, 'type');
        const props = __props;
        const openOnRender = _useModel(__props, 'openOnRender');
        const menuIsVisible = ref(openOnRender.value);
        const initialType = ref(props.initialType);
        const changedValue = ref(undefined);
        changedValue.value = model.value;
        const selectedType = ref(type);
        const emit = __emit;
        const typeItemsNumber = ref([
            {
                text: t('common.filters.='),
                value: FilterType.Equal,
            },
            {
                text: t('common.filters.<'),
                value: FilterType.Smaller,
            },
            {
                text: t('common.filters.>'),
                value: FilterType.Greater,
            }
        ]);
        const applyButtonTextComputed = ref(props.applyButtonText ?? t('common.filters.apply'));
        const resetButtonTextComputed = ref(props.resetButtonText ?? t('common.filters.reset'));
        const noFilterTextComputed = ref(props.noFilterText ?? t('common.dataGrid.selectAll'));
        const displayString = ref(noFilterTextComputed.value);
        const getDisplayString = function (value) {
            const valueString = value || noFilterTextComputed.value;
            let string = valueString;
            if (props.isMoney && valueString !== noFilterTextComputed.value) {
                string += '€';
            }
            return string;
        };
        const emitUpdate = function (value) {
            /**
             * Triggers when the filter is updated.
             */
            emit(FilterEvent.Input, changedValue.value);
            /**
             * Triggers when the type is updated.
             */
            emit('update:type', selectedType.value);
            emit('update:modelValue', changedValue.value);
            emit(FilterEvent.FilterUpdated, value);
        };
        const { returnTypeId, returnId, shouldShowPrefixComputed, returnFilterButtonId, } = useFilter(props, { emit }, model, undefined);
        const resetFilter = function () {
            emit(FilterEvent.FilterReset);
        };
        const applyFilters = function () {
            updateDisplayString(changedValue.value);
            menuIsVisible.value = false;
            emitUpdate(changedValue.value);
        };
        const onResetButtonClicked = function () {
            changedValue.value = undefined;
            selectedType.value = initialType.value;
            updateDisplayString(undefined);
            menuIsVisible.value = false;
            emitUpdate(undefined);
        };
        const updateDisplayString = function (value) {
            displayString.value = getDisplayString(value);
        };
        watch(() => type, (newType, oldType) => {
            selectedType.value = newType;
            emit('update:type', newType);
        });
        watch(() => model, (newValue, oldValue) => {
            changedValue.value = model.value;
            updateDisplayString(model.value);
        });
        watch(menuIsVisible, (newValue) => {
            emit('update:openOnRender', newValue);
        });
        onMounted(() => {
            updateDisplayString(model.value);
        });
        const __returned__ = { model, type, props, openOnRender, menuIsVisible, initialType, changedValue, selectedType, emit, typeItemsNumber, applyButtonTextComputed, resetButtonTextComputed, noFilterTextComputed, displayString, getDisplayString, emitUpdate, returnTypeId, returnId, shouldShowPrefixComputed, returnFilterButtonId, resetFilter, applyFilters, onResetButtonClicked, updateDisplayString, EnFilterButtonBase, EnFilterTypeSelectButton, get EnTextField() { return EnTextField; }, EnFilterButtonTypePrefix };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
